let metafieldValue = [];
let key = '';
let customOrderName = '';
let productCaseUnits = [];
let totalProductsToCart = 0;
let productTags = [];
let rowIndexList = {};
let formLoaded = false;
let isRequestPending = false;
let debounceTimer;

if (!customElements.get('custom-order-list')) {
  customElements.define(
    'custom-order-list',
    class CustomOrderList extends HTMLElement {
      constructor() {
        super();
        formLoaded = false;
        this.renderList();
        if (formLoaded) {
          rowIndexList = {};
          this.setIndex(true);
        }
      }
      async renderList() {
        let sum = 0.0;
        let rows = '';
        let orderLineItems = [];
        let parsedMetaValues = [];
        let errorMessage = '';

        await $.ajax({
          url: 'https://dev80.p80w.com/advantagebox/public/getCustomOrderFormProducts',
          type: 'GET',
          crossDomain: true,
          data: {
            customer_id: customerID,
            custom_order_form_id: metaId,
          },
          async: false,
        })
          .done(function (response) {
            if (!response.error && !response.body?.errors) {
              formLoaded = true;
              key = response.body.body.metafield.key;
              metafieldValue = response.body?.body?.metafield?.value
                ? JSON.parse(response.body.body.metafield.value)
                : [];
              if (
                !response?.products ||
                (response?.products && Object.values(response.products).length == 0)
              ) {
                formLoaded = false;
                errorMessage = 'No products found';
                return;
              }
              parsedMetaValues = parseMetaValues(metafieldValue);
              orderLineItems = response.products;
              customOrderName = metafieldValue?.[0]?.custom_order_name.replace(/-/g, ' ') ?? '';
              $('#customOrderName').val(customOrderName);
              $('#custom_order_name').text(customOrderName);
              $('.customOrderName').text(customOrderName);
            } else {
              formLoaded = false;
              if (response?.body?.errors) {
                errorMessage = response.body.errors;
              }
            }
          })
          .fail(function (err) {
            formLoaded = false;
            if (err?.responseJSON && err?.responseJSON?.error) {
              errorMessage = err.responseJSON.body;
            }
          });

        if (!formLoaded) {
          errorMessage = errorMessage ? errorMessage : 'No products found';
          rows = `<tr><td class="danger-message" colspan="6">${errorMessage}</td></tr>`;
        } else {
          let collectionIndex = 0;
          let pCounter = 1;

          const productRows = await Promise.all(
            Object.values(orderLineItems).map(async (product) => {
              let metaData = parsedMetaValues[product.variant_id] ?? null;
              if (!metaData) return '';

              let itemTotal = metaData.total ? metaData.total : '0.00';
              sum += parseFloat(itemTotal.replace(/[$,]/g, ''));
              pCounter++;

              const packageDetails = getQuantityKey(product.tags);
              const caseUnitKeys = packageDetails.caseUnitValue;
              const bulkUnitKeys = packageDetails.bulkUnitValue;
              const packingMessages = packageDetails.packingMessages;
              const caseKeyValues = packageDetails.caseKeyValue;

              let orderQuantityEle = '';
              productTags[metaData.variant_id] =
                Object.keys(product.tags).length > 0 ? product.tags.join(',') : '';

              if (Object.keys(caseUnitKeys).length > 0) {
                orderQuantityEle += orderQuantityElement(
                  caseUnitKeys,
                  product,
                  metaData,
                  caseKeyValues,
                  'case_unit',
                );
              }
              if (Object.keys(bulkUnitKeys).length > 0) {
                orderQuantityEle += orderQuantityElement(
                  bulkUnitKeys,
                  product,
                  metaData,
                  caseKeyValues,
                  'bulk_unit',
                  product.availableForSale,
                );
              }

              let variantPriceCents = product.price.replace(/\$/g, '').replace(/\,/g, '') * 100;
              try {
                const variant = await fetch(`/variants/${metaData.variant_id}.js`).then((res) =>
                  res.json(),
                );
                variantPriceCents = variant.price;
              } catch (error) {
                console.error('Error fetching variant:', error);
              }

              collectionIndex++;

              return `
                <tr
                  draggable="true"
                  data-track-table=""
                  data-after-price-text="${product?.metafields?.text_after_price?.value || ''}"
                  data-index-loop=""
                  id="tr--p80w-${product.id}"
                  data-vendor="${product.brand}"
                  data-sku="${product.sku}"
                  data-handle="${product.handle}"
                  data-url="/products/${product.handle}"
                  data-image="${product.image.replace('width=200', 'width=400')}"
                  data-measurements="${(product?.metafields?.measurements?.value || '').replace(
                    /"/g,
                    '&quot;',
                  )}"
                  data-dimensions="${(product?.metafields?.dimensions?.value || '').replace(
                    /"/g,
                    '&quot;',
                  )}"
                  data-price="${variantPriceCents}"
                  data-id="${metaData.variant_id}"
                  data-collection-index="${collectionIndex}"
                  data-packing="${
                    Object.keys(packingMessages).length > 0 ? packingMessages.join(', ') : ''
                  }"
                  data-description="${product.description.replace(/["']/g, '&quot;')}"
                  class="hide-display-on-print product-list-tr collection-item-${collectionIndex}"                
                  data-title="${product.title.replace(/["']/g, '&quot;')}">
                  
                  <td class="drag-button-td"><button class="drag-button">
                  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="2" cy="2" r="2" fill="#221F1D"/>
                    <circle cx="9" cy="2" r="2" fill="#221F1D"/>
                    <circle cx="2" cy="9" r="2" fill="#221F1D"/>
                    <circle cx="9" cy="9" r="2" fill="#221F1D"/>
                    <circle cx="2" cy="16" r="2" fill="#221F1D"/>
                    <circle cx="9" cy="16" r="2" fill="#221F1D"/>
                  </svg>
                  </button></td>
                  <td class="product-name">
                    <a class="show-custom-modal product" href="/products/${
                      product.handle
                    }?variant=${metaData.variant_id}">
                      <div class="product">
                        <div class="image"><img src="${product.image}" alt=""/></div>
                        <div class="content">
                          <div class="title">${product.title.replace(/["']/g, '&quot;')}</div>
                          <div class="sku">SKU: ${product.sku}</div>
                        </div>
                      </div>
                    </a>
                  </td>
                  <td class="product-price text-center">
                    ${theme.Currency.formatMoney(variantPriceCents, theme.moneyFormat)}
                    ${
                      product?.metafields?.text_after_price?.value
                        ? product.metafields.text_after_price.value
                        : ''
                    }
                  </td>
                  <td class="product-quantity">
                    <div class="display-on-mobile-only">
                      <div class="title">${product.title.replace(/["']/g, '&quot;')}</div>
                    </div>
                    <div class="mobile-form-field-header">Order Quantity</div>
                    <div class="d-flex">
                      ${orderQuantityEle}
                    </div>
                  </td>
                  <td class="total-qty-block">
                    <div class="mobile-form-field-header">Product Quantity</div>
                    <span id="total-qty-${
                      metaData.variant_id
                    }" data-total-qty="0" class="total-qty">0 unit</span>
                  </td>
                  <td class="Total">
                    <div class="mobile-form-field-header">Total</div>
                    <div id="total-price-${
                      metaData.variant_id
                    }" data-product-price-total="0" class="text-center price-total-- co-product-price">
                      $0.00
                    </div>
                  </td>
                  <td class="delete-btn-block">
                    <button class="delete-button" data-id="${metaData.variant_id}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16">
                          <g fill="#221F1D">
                              <path d="M4.887.966H7.56v.45h.965V.903C8.526.405 8.122 0 7.624 0h-2.8c-.498 0-.903.405-.903.903v.513h.966v-.45zM10.757 5.242H1.69c-.249 0-.444.212-.424.46l.758 9.372c.042.523.478.926 1.003.926H9.42c.524 0 .96-.403 1.002-.926l.758-9.372c.02-.248-.175-.46-.423-.46zM3.886 15l-.03.001c-.254 0-.466-.197-.482-.453L2.9 6.854c-.016-.266.186-.495.452-.512.266-.016.496.186.512.453l.475 7.694c.016.266-.186.495-.452.511zm2.826-.482c0 .267-.216.483-.483.483s-.483-.216-.483-.483V6.824c0-.266.216-.483.483-.483s.483.217.483.483v7.694zm2.836-7.665l-.453 7.694c-.015.256-.228.454-.482.454h-.029c-.266-.016-.47-.245-.453-.511l.453-7.694c.016-.266.243-.47.51-.454.267.016.47.245.454.51zM12.427 3.752l-.318-.95c-.083-.251-.318-.42-.582-.42H.92c-.264 0-.499.169-.582.42l-.317.95c-.061.183.018.37.167.464.06.038.132.06.21.06h11.65c.08 0 .151-.022.212-.06.148-.094.228-.28.167-.464z"/>
                          </g>
                      </svg>
                    </button>
                  </td>
                </tr>`;
            }),
          );

          rows = productRows.join('');
        }

        let table = `<table id="table-b2b-headers">
          <thead>
            <tr>
              <th class="drag-btn-block"></th>
              <th class="text-center">PRODUCT</th>
              <th class="text-center th-unit-price">UNIT PRICE</th>
              <th class="text-center order-qty-header">ORDER&nbsp;QUANTITY</th>
              <th class="text-center th-qty">PRODUCT&nbsp;QUANTITY</th>
              <th class="text-center">TOTAL</th>
              <th class="delete-btn-block"></th>
            </tr>
          </thead>
          <tbody>
            ${rows}
          </tbody>
        </table>`;

        $('#totalPrice').text(theme.Currency.formatMoney(0 * 100, theme.moneyFormat));
        this.innerHTML = table || '';
        this.initDrag(this);
      }

      setIndex(initial = false) {
        const rows = this.querySelectorAll('tr[draggable="true"]');
        if (initial) {
          rows.forEach((row, index) => {
            rowIndexList[row.dataset.id] = index;
          });
        } else {
          let updatedFlag = false;
          rows.forEach((row, index) => {
            const variantId = row.dataset.id;
            const currentRowIndex = row.rowIndex - 1;
            if (rowIndexList[variantId] !== currentRowIndex) {
              rowIndexList[variantId] = currentRowIndex;
              updatedFlag = true;
            }
          });
        }
      }
      initDrag() {
        const table = document.getElementById('table-b2b-headers');
        let draggingElement;

        const handleDragStart = (event) => {
          draggingElement = event.target.closest('tr');
          draggingElement.classList.add('dragging');
        };

        const handleDragOver = (event) => {
          event.preventDefault();
          const target = event.target.closest('tr');
          if (target && target !== draggingElement) {
            const bounding = target.getBoundingClientRect();
            const offset = bounding.y + bounding.height / 2;
            const nextElement = event.clientY - offset > 0 ? target.nextElementSibling : target;
            if (nextElement !== draggingElement) {
              if (nextElement) {
                table.querySelector('tbody').insertBefore(draggingElement, nextElement);
              } else {
                table.querySelector('tbody').appendChild(draggingElement);
              }
            }
            const viewportHeight = window.innerHeight;
            const mousePosition = event.clientY;
            if (mousePosition < 100) {
              window.scrollBy(0, -30);
            } else if (viewportHeight - mousePosition < 100) {
              window.scrollBy(0, 30);
            }
          }
        };

        const handleDrop = (event) => {
          event.preventDefault();
          this.setIndex();
          draggingElement.classList.remove('dragging');
          draggingElement = null;
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            updateLineItemPosition();
          }, 500);
        };

        table.querySelectorAll('tbody tr').forEach((row) => {
          row.addEventListener('dragstart', handleDragStart);
          row.addEventListener('dragover', handleDragOver);
          row.addEventListener('drop', handleDrop);
          row.draggable = true;
        });
      }
      setRowIndex() {
        const table = document.getElementById('table-b2b-headers');
        table.querySelectorAll('tbody tr').forEach((row, index) => {
          row.dataset.indexLoop = index;
        });
      }
    },
  );
}

/** returns quantity element */
function orderQuantityElement(
  unitKeys,
  product,
  metaData,
  caseKeyValues,
  quantityType,
  availableForSale = true,
) {
  let orderQuantityEle = '';
  Object.values(unitKeys).forEach((key) => {
    if (metaData[key] == undefined) return false;

    let caseKey = key;
    let caseLabel = key;
    if (quantityType === 'case_unit' && product?.metafields?.text_above_first_textfield?.value) {
      caseLabel = product.metafields.text_above_first_textfield.value;
    }
    if (quantityType === 'bulk_unit' && product?.metafields?.text_above_second_textfield?.value) {
      caseLabel = product.metafields.text_above_second_textfield.value;
    }

    if (!productCaseUnits[metaData.variant_id]) {
      productCaseUnits[metaData.variant_id] = {};
    }
    console.log(product);
    productCaseUnits[metaData.variant_id][caseKey] = caseKeyValues[caseKey];
    orderQuantityEle += `
      <div>
        <div class="small-label" for="orderQuantity-${product.id}-${caseKey}">${caseLabel}</div>
        <div class="product-qty-wrap  ${!availableForSale ? 'disabled-div' : ''}">
          <span data-id="${metaData.variant_id}" class="qty--minus">-</span><span data-id="${
      metaData.variant_id
    }" class="qty--add">+</span>
          <input type="number" id="orderQuantity-${product.id}-${caseKey}" 
            class="product-qty order-quantity-input orderQuantity order-qty-${
              metaData.variant_id
            }" data-id="${metaData.variant_id}" 
            data-key="${caseKey}" 
            data-product-price="${product.price.replace(/[$,]/g, '')}" value="0" min="0">
        </div>
      </div>`;
  });
  return orderQuantityEle;
}

/** update line item position */
function updateLineItemPosition() {
  const body = {
    customer_id: customerID,
    custom_order_form_id: metaId,
    positions: JSON.stringify(rowIndexList),
  };
  $.ajax({
    url: 'https://dev80.p80w.com/advantagebox/public/updateCustomOrderFormPosition',
    type: 'PUT',
    crossDomain: true,
    data: body,
    beforeSend: function () {
      if (isRequestPending) {
        return false; // Cancel if another request is still pending
      }
      isRequestPending = true;
    },
  })
    .done(function (response) {
      if (!response.error && !response.body?.errors) {
        console.log(response.body);
      }
    })
    .fail(function (err) {})
    .complete(function () {
      isRequestPending = false;
    });
}
$(document).on('keydown', '.order-quantity-input', function (event) {
  if (event.key === '.') {
    event.preventDefault();
  }
});

$(document).on('input', '.order-quantity-input', function (e) {
  e.target.value = e.target.value.replace(/[^0-9]*/g, '');
  if (Math.abs($(this).val()) == 0) {
    $(this).val('0');
  }
});

$(document).on('click', '.qty--add', function (e) {
  $(this)
    .siblings('input')
    .val(parseFloat($(this).siblings('input').val()) + 1)
    .trigger('change');
});
$(document).on('click', '.qty--minus', function () {
  let min_value = parseFloat($(this).siblings('input').attr('min')) ?? 0;
  if (parseFloat($(this).siblings('input').val()) > min_value)
    $(this)
      .siblings('input')
      .val(parseFloat($(this).siblings('input').val()) - 1)
      .trigger('change');
});

$(document).ready(function () {
  if (token)
    $.ajaxSetup({
      headers: {
        token: token,
      },
    });

  // reload page on back button
  window.onpageshow = function (event) {
    const navigationEntries = performance.getEntriesByType('navigation');
    const isBackNavigation =
      navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward';
    if (event.persisted || isBackNavigation) {
      renderCustomOrder();
    }
  };

  renderCustomOrder();
});

$(document).on('click', '.delete-button', function () {
  let variantID = $(this).data('id');
  let collectionIndex = $(this).data('collection-index');
  $.ajax({
    url: 'https://dev80.p80w.com/advantagebox/public/removeProductCustomOrderForm',
    type: 'POST',
    crossDomain: true,
    data: {
      variant_id: variantID,
      customer_id: customerID,
      custom_order_form_id: metaId,
    },
    async: false,
  })
    .done(function (response) {
      if (!response.error) {
        $('tr[data-id="' + variantID + '"]').remove();
        delete rowIndexList[variantID];
      }
      if ($('.collection-item' + collectionIndex).length == 0)
        $('.product-collection-' + collectionIndex).remove();
      //alert('Product Removed from the Customer Order Form');
    })
    .fail(function (err) {
      console.log(err);
    });
  renderCustomOrder();
});

$(document).on('click', '#updateCustomOrder', function () {
  let updatedName = $('#customOrderName').val().replace(/\s/g, '-');
  if (customOrderName != updatedName) {
    const body = {
      customer_id: customerID,
      prop: 'custom_order_name',
      value: updatedName,
      custom_order_form_id: metaId,
    };
    let response = updateMetafield(body);
    if (response) {
      $('#customOrderName').val(updatedName);
      // renderCustomOrder();
    }
  }
});

$(document).on('change', '.orderQuantity', function () {
  const variantId = $(this).data('id');
  // const caseUnit = $(this).data('case-unit');
  // const productUnitPrice = $(this).data('product-price');
  // let quantity = this.value;

  let productTotalPrice = 0;
  let productTotalUnit = 0;
  if ($('.order-qty-' + variantId).length > 0) {
    $('.order-qty-' + variantId).each(function () {
      const key = $(this).data('key');
      const caseUnit = productCaseUnits[variantId][key];
      let price = $(this).closest('tr').data('price');
      if (price == null || price === 0) {
        price = $(this).data('product-price');
      }
      const productUnitPrice = price / 100;
      const quantity = this.value;
      console.log('quantity', quantity);
      console.log('caseUnit', caseUnit);
      console.log('productUnitPrice', productUnitPrice);
      const calValue = calculateUnitAndPrice(quantity, caseUnit, productUnitPrice);
      productTotalPrice += calValue.totalPrice;
      productTotalUnit += calValue.totalUnit;
    });
  }

  $('#total-price-' + variantId).html(
    '$' +
      productTotalPrice
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
  );
  $('#total-price-' + variantId).attr(
    'data-product-price-total',
    productTotalPrice
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
  );

  $('#total-qty-' + variantId).attr('data-total-qty', productTotalUnit);
  $('#total-qty-' + variantId).html(
    productTotalUnit > 1
      ? productTotalUnit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' units'
      : productTotalUnit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' unit',
  );
  let sum = 0;
  if ($('.co-product-price').length > 0) {
    $('.co-product-price').each(function (element) {
      sum += parseFloat(this.dataset.productPriceTotal.replace(/\,/g, ''));
    });
  }
  $('#totalPrice').html(
    '$ ' +
      sum
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
  );
  let totalQuantity = 0;
  $('.product-list-tr').each(function () {
    let variantID = $(this).data('id');
    let quantity = document.getElementById('total-qty-' + variantID).dataset.totalQty;
    totalQuantity += quantity;
  });
  if (totalQuantity > 0) $('.custom-add-to-cart').prop('disabled', false);
  else $('.custom-add-to-cart').prop('disabled', true);
  // const body = {
  //   customer_id: customerID,
  //   prop: key,
  //   value: quantity,
  //   custom_order_form_id: metaId,
  //   product_id: productID,
  // };
  // let response = updateMetafield(body);
  // if (response) {
  //   renderCustomOrder();
  // }
});

function calculateUnitAndPrice(quantity, caseUnit, productUnitPrice) {
  const totalUnit = caseUnit * quantity;
  console.log('totalunit', totalUnit);
  const totalPrice = caseUnit * quantity * productUnitPrice;
  return {totalUnit, totalPrice};
}
$('#deleteCustomOrder').on('click', function () {
  $.ajax({
    url: 'https://dev80.p80w.com/advantagebox/public/removeCustomOrderForm',
    type: 'POST',
    crossDomain: true,
    data: {
      customer_id: customerID,
      custom_order_form_id: metaId,
    },
    async: false,
  })
    .done(function (response) {
      productCaseUnits = [];
      alert('Custom Order Form deleted');
      window.location.href = '/collections/all-products';
    })
    .fail(function (err) {
      console.log(err);
    });
});

function renderCustomOrder() {
  $('#itemList').html('<custom-order-list></custom-order-list>');
}

function updateMetafield(body) {
  console.log(body);
  let result;

  $.ajaxSetup({
    headers: {
      token: token,
    },
  });
  $.ajax({
    url: 'https://dev80.p80w.com/advantagebox/public/updateCustomOrderForm',
    type: 'PUT',
    crossDomain: true,
    data: body,
    async: false,
  })
    .done(function (response) {
      if (!response.error && !response.body?.errors) {
        //alert("Order form updated");
        window.reload;
        if (response.status == 'deleted') {
          window.location.href = '/collections/all-products';
        }
        result = response;
        setMetafieldValue();
      }
    })
    .fail(function (err) {
      console.log('err', err);
    });
  return result;
}

function capitalizeWords(str) {
  let words = str.split(' ');
  let capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  let result = capitalizedWords.join(' ');
  return result;
}

function getQuantityKey(tags) {
  let packingMessages = [];
  let caseUnitValue = [];
  let bulkUnitValue = [];
  let caseKeyValue = {};
  const tagString = Object.keys(tags).length > 0 ? tags.join(',') : '';

  Object.values(tags).forEach((tag) => {
    if (tag.includes('each:')) {
      packingMessages.push(tag.split(':')[1] + ' each');
      caseUnitValue = ['each'];
      caseKeyValue.each = tag.split(':')[1];
    }
    if (tag.includes('kit:')) {
      packingMessages.push(tag.split(':')[1] + ' kit');
      caseUnitValue = ['kit'];
      caseKeyValue.kit = tag.split(':')[1];
      caseKeyValue.kits = tag.split(':')[1];
    }
    if (tag.includes('sheet:')) {
      packingMessages.push(tag.split(':')[1] + ' per sheet');
      caseUnitValue = ['sheet', 'sheets'];
      caseKeyValue.sheet = tag.split(':')[1];
      caseKeyValue.sheets = tag.split(':')[1];
    }
    if (tag.includes('bundle:')) {
      packingMessages.push(tag.split(':')[1] + ' per bundle');
      caseUnitValue = ['bundle', 'bundles'];
      caseKeyValue.bundle = tag.split(':')[1];
      caseKeyValue.bundles = tag.split(':')[1];
    }
    if (tag.includes('bale:')) {
      packingMessages.push(tag.split(':')[1] + ' per bale');
      caseUnitValue = ['bale', 'bales'];
      caseKeyValue.bale = tag.split(':')[1];
      caseKeyValue.bales = tag.split(':')[1];
    }
    if (tag.includes('roll:')) {
      packingMessages.push(tag.split(':')[1] + ' per roll');
      caseUnitValue = ['roll', 'rolls'];
      caseKeyValue.roll = tag.split(':')[1];
      caseKeyValue.rolls = tag.split(':')[1];
    }
    if (tag.includes('flat:')) {
      packingMessages.push(tag.split(':')[1] + ' per flat');
      caseUnitValue = ['flat', 'flats'];
      caseKeyValue.flat = tag.split(':')[1];
      caseKeyValue.flats = tag.split(':')[1];
    }
    if (tag.includes('set:')) {
      packingMessages.push(tag.split(':')[1] + ' per set');
      caseUnitValue = ['set', 'sets'];
      caseKeyValue.set = tag.split(':')[1];
      caseKeyValue.sets = tag.split(':')[1];
    }
    if (tag.includes('box:')) {
      packingMessages.push(tag.split(':')[1] + ' per box');
      caseUnitValue = ['box', 'boxes'];
      caseKeyValue.box = tag.split(':')[1];
      caseKeyValue.boxes = tag.split(':')[1];
    }
    if (tag.includes('coil:')) {
      packingMessages.push(tag.split(':')[1] + ' per coil');
      caseUnitValue = ['coil', 'coils'];
      caseKeyValue.coil = tag.split(':')[1];
      caseKeyValue.coils = tag.split(':')[1];
    }
    if (tag.includes('pair:')) {
      packingMessages.push(tag.split(':')[1] + ' per pair');
      caseUnitValue = ['pair', 'pairs'];
      caseKeyValue.pair = tag.split(':')[1];
      caseKeyValue.pairs = tag.split(':')[1];
    }
    if (tag.includes('pack:') && tagString.includes('pallet:')) {
      packingMessages.push(tag.split(':')[1] + ' per pack');
      caseUnitValue = ['pack', 'packs'];
      caseKeyValue.pack = tag.split(':')[1];
      caseKeyValue.packs = tag.split(':')[1];
    }
    if (tag.includes('case:') && tagString.includes('pallet:')) {
      packingMessages.push(tag.split(':')[1] + ' per case');
      caseUnitValue = ['case', 'cases'];
      caseKeyValue.case = tag.split(':')[1];
      caseKeyValue.cases = tag.split(':')[1];
    }
    if (tag.includes('case:')) {
      packingMessages.push(tag.split(':')[1] + ' per case');
      bulkUnitValue = ['case', 'cases'];
      caseKeyValue.case = tag.split(':')[1];
      caseKeyValue.cases = tag.split(':')[1];
    }
    if (tag.includes('pallet:')) {
      packingMessages.push(tag.split(':')[1] + ' per pallet');
      bulkUnitValue = ['pallet', 'pallets'];
      caseKeyValue.pallet = tag.split(':')[1];
      caseKeyValue.pallets = tag.split(':')[1];
    }
    if (tag.includes('box_bulk:')) {
      packingMessages.push(tag.split(':')[1] + ' per box bulk');
      bulkUnitValue = ['box_bulk', 'box_bulks'];
      caseKeyValue.box_bulk = tag.split(':')[1];
      caseKeyValue.box_bulks = tag.split(':')[1];
    }
    if (tag.includes('carton:')) {
      packingMessages.push(tag.split(':')[1] + ' per carton');
      bulkUnitValue = ['carton', 'cartons'];
      caseKeyValue.carton = tag.split(':')[1];
      caseKeyValue.cartons = tag.split(':')[1];
    }
    if (tag.includes('bag:')) {
      packingMessages.push(tag.split(':')[1] + ' per bag');
      bulkUnitValue = ['bag', 'bags'];
      caseKeyValue.bag = tag.split(':')[1];
      caseKeyValue.bags = tag.split(':')[1];
    }
    if (tag.includes('pack:')) {
      packingMessages.push(tag.split(':')[1] + ' per pack');
      bulkUnitValue = ['pack', 'packs'];
      caseKeyValue.pack = tag.split(':')[1];
      caseKeyValue.packs = tag.split(':')[1];
    }
    if (tag.includes('boxes:')) {
      packingMessages.push(tag.split(':')[1] + ' per box');
      bulkUnitValue = ['box', 'boxes'];
      caseKeyValue.box = tag.split(':')[1];
      caseKeyValue.boxs = tag.split(':')[1];
    }
    if (tag.includes('box:') && tagString.includes('each:')) {
      packingMessages.push(tag.split(':')[1] + ' per box');
      bulkUnitValue = ['box', 'boxes'];
      caseKeyValue.box = tag.split(':')[1];
      caseKeyValue.boxs = tag.split(':')[1];
    }
    if (tag.includes('dozen:')) {
      packingMessages.push(tag.split(':')[1] + ' per dozen');
      bulkUnitValue = ['dozen', 'dozens'];
      caseKeyValue.dozen = tag.split(':')[1];
      caseKeyValue.dozens = tag.split(':')[1];
    }
  });
  caseUnitValue = arrayUnique(caseUnitValue);
  bulkUnitValue = arrayUnique(bulkUnitValue);
  packingMessages = arrayUnique(packingMessages);
  let result = {packingMessages, caseKeyValue, caseUnitValue, bulkUnitValue};
  return result;
}

function arrayUnique(array) {
  return array.filter((value, index, self) => {
    return self.indexOf(value) === index;
  });
}

function parseMetaValues(metafieldValues) {
  let result = [];
  Object.values(metafieldValues).forEach((value) => {
    result[value.variant_id] = value;
  });
  return result;
}

function setMetafieldValue() {
  $.ajax({
    url: 'https://dev80.p80w.com/advantagebox/public/getCustomOrderFormById',
    type: 'GET',
    crossDomain: true,
    data: {
      customer_id: customerID,
      custom_order_form_id: metaId,
    },
    async: false,
  })
    .done(function (response) {
      if (!response && !response.metafields) {
        key = response.metafield.key;
        metafieldValue = JSON.parse(response.metafield.value);
        customOrderName = metafieldValue[0].custom_order_name.replace(/-/g, ' ') ?? '';
        $('#customOrderName').val(customOrderName);
        $('#custom_order_name').text(customOrderName);
      }
    })
    .fail(function (err) {
      console.log(err);
    });
}

$('.custom-add-to-cart').on('click', function () {
  const items = [];
  $('.product-list-tr').each(function () {
    const variantID = $(this).data('id');
    const quantity = document.getElementById('total-qty-' + variantID).dataset.totalQty;
    if (quantity > 0) {
      const properties = {__tags: productTags[variantID]};
      items.push({
        id: variantID.toString(),
        quantity: parseInt(quantity),
        properties,
      });
    }
  });
  if (Object.values(items).length > 0) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({items}),
    })
      .then((response) => {
        window.location.href = '/cart';
      })
      .catch((response) => {
        console.log('err', response);
      });
  }
});

$(document).on('click', '.show-custom-modal', function (e) {
  e.preventDefault();
  let productHandle = $(this).parent().parent().data('handle');
  let productImage = $(this).parent().parent().data('image');
  let productTitle = $(this).parent().parent().data('title');
  let productSku = $(this).parent().parent().data('sku');
  let productBrand = $(this).parent().parent().data('vendor');
  let productPacking = $(this).parent().parent().data('packing');
  let productContent = $(this).parent().parent().data('description');

  console.log('productContent', productContent);

  if (productImage) {
    $('#product-modal-image').removeClass('hide');
    $('#product-modal-image').attr('src', productImage);
  }
  $('#product-modal-title').html(`<a href="/products/${productHandle}">${productTitle}</a>`);
  $('#product-modal-sku').html(
    '<span class="label">SKU: </span><span class="data-val">' + productSku + '</span>',
  );
  $('#product-modal-brand').html(
    '<span class="label">Brand: </span><span class="data-val">' + productBrand + '</span>',
  );
  $('#product-modal-packing').html(
    '<span class="label">Packing: </span><span class="data-val">' + productPacking + '</span>',
  );
  $('#product-modal-content')
    .removeClass('hide')
    .html('<span class="label">Details: </span><span class="data-val">' + productContent);
  $('.product-info-modal').fadeIn(300);
});
$(document).on('click', '.custom-modal-close', function (e) {
  e.preventDefault();
  $('#product-modal-content').addClass('hide');
  $('#product-modal-image').addClass('hide');
  $('.product-info-modal').fadeOut(300);
});
